(function() {
  const tabs = document.querySelectorAll('.tmt-tab-btn');
  const panels = document.querySelectorAll('.tmt-tab-panel');

  tabs.forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.tab;

      tabs.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');

      const currentPanel = document.querySelector('.tmt-tab-panel.is-active');
      const nextPanel = document.querySelector(`.tmt-tab-panel[data-panel="${target}"]`);

      if (currentPanel === nextPanel) return;

      currentPanel.style.opacity = '0';
      setTimeout(() => {
        currentPanel.classList.remove('is-active');
        nextPanel.classList.add('is-active');
        nextPanel.style.opacity = '0';
        requestAnimationFrame(() => {
          nextPanel.style.opacity = '1';
        });
      }, 0);
    });
  });

  const tabNav = document.getElementById('tmt-tabs');
  if (tabNav) {
    tabNav.addEventListener('touchstart', function(e) {
      this._startX = e.touches[0].clientX;
      this._startY = e.touches[0].clientY;
    }, { passive: true });

    tabNav.addEventListener('touchmove', function(e) {
      const dy = Math.abs(e.touches[0].clientY - this._startY);
      if (dy > 0) {
        e.preventDefault();
      }
    }, { passive: false });
  }

  // ヘッダーのスクロール半透明化
  const header = document.querySelector('.tmt-fixed-header');
  if (header) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 10) {
        header.style.background = 'rgba(255, 255, 255, 0.85)';
        header.style.webkitBackdropFilter = 'blur(8px)';
        header.style.backdropFilter = 'blur(8px)';
      } else {
        header.style.background = '#fff';
        header.style.webkitBackdropFilter = 'none';
        header.style.backdropFilter = 'none';
      }
    }, { passive: true });
  }

  // タブパネルのスワイプ切り替え
  let startX = 0;
  let startY = 0;

  document.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
  }, { passive: true });

  document.addEventListener('touchend', (e) => {
    const dx = e.changedTouches[0].clientX - startX;
    const dy = e.changedTouches[0].clientY - startY;

    if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 50) {
      const activeBtn = document.querySelector('.tmt-tab-btn.is-active');
      if (!activeBtn) return;
      const currentIndex = parseInt(activeBtn.dataset.tab);
      const total = document.querySelectorAll('.tmt-tab-btn').length;

      let nextIndex;
      if (dx < 0) {
        nextIndex = Math.min(currentIndex + 1, total);
      } else {
        nextIndex = Math.max(currentIndex - 1, 1);
      }

      if (nextIndex !== currentIndex) {
        const targetBtn = document.querySelector(`.tmt-tab-btn[data-tab="${nextIndex}"]`);
        if (targetBtn) {
          targetBtn.click();
        }
      }
    }
  }, { passive: true });

  // タブナビ関連
  if (tabNav) {

    // 選択タブを中央にスクロール（PCもスマホも共通）
    tabNav.addEventListener('click', (e) => {
      const btn = e.target.closest('.tmt-tab-btn');
      if (!btn) return;
      btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    });

    // スマホ：タブナビを慣性スワイプでスクロール
    let tStartX = 0, tLastX = 0, tLastTime = 0;
    let tVelocity = 0, tRafId = null;

    function applyTabInertia() {
      tVelocity *= 0.92;
      if (Math.abs(tVelocity) < 0.3) { tVelocity = 0; return; }
      tabNav.scrollLeft += tVelocity;
      tRafId = requestAnimationFrame(applyTabInertia);
    }

    tabNav.addEventListener('touchstart', (e) => {
      tVelocity = 0;
      if (tRafId) cancelAnimationFrame(tRafId);
      tStartX = e.touches[0].clientX;
      tLastX = tStartX;
      tLastTime = Date.now();
    }, { passive: true });

    tabNav.addEventListener('touchmove', (e) => {
      tabNav.scrollLeft -= (e.touches[0].clientX - tLastX);
      const now = Date.now();
      const dt = now - tLastTime;
      if (dt > 0) tVelocity = (tLastX - e.touches[0].clientX) / dt * 40;
      tLastX = e.touches[0].clientX;
      tLastTime = now;
    }, { passive: true });

    tabNav.addEventListener('touchend', () => {
      tRafId = requestAnimationFrame(applyTabInertia);
    }, { passive: true });

    // スクロール位置に応じてフェードマスクを切り替え（スマホのみ）
    function updateTabMask() {
      if (window.innerWidth > 768) {
        tabNav.style.webkitMaskImage = 'none';
        tabNav.style.maskImage = 'none';
        return;
      }

      const scrollLeft = tabNav.scrollLeft;
      const maxScroll = tabNav.scrollWidth - tabNav.clientWidth;
      const atStart = scrollLeft < 4;
      const atEnd = scrollLeft > maxScroll - 4;

      if (atStart) {
        tabNav.style.webkitMaskImage = 'linear-gradient(to right, black 70%, transparent 100%)';
        tabNav.style.maskImage = 'linear-gradient(to right, black 70%, transparent 100%)';
      } else if (atEnd) {
        tabNav.style.webkitMaskImage = 'linear-gradient(to left, black 70%, transparent 100%)';
        tabNav.style.maskImage = 'linear-gradient(to left, black 70%, transparent 100%)';
      } else {
        tabNav.style.webkitMaskImage = 'linear-gradient(to right, transparent 0%, black 15%, black 75%, transparent 100%)';
        tabNav.style.maskImage = 'linear-gradient(to right, transparent 0%, black 15%, black 75%, transparent 100%)';
      }
    }

    tabNav.addEventListener('scroll', updateTabMask, { passive: true });
    window.addEventListener('resize', updateTabMask, { passive: true });
    updateTabMask();
  }

})();
